import { css } from 'styled-components';

export interface FontFaceSpec {
    family: string;
    weights: Array<{
        weight: number;
        woff: string;
        woff2: string;
    }>;
}

const resolveAssetUrl = (assetPath: string) => {
    try {
        if (import.meta.url) {
            return new URL(assetPath, import.meta.url).href;
        }
    } catch {
        // ignore
    }

    // In bundlers like Webpack/Vite the string already resolves to the final asset URL.
    return assetPath;
};

export function createFontFace({ family, weights }: FontFaceSpec) {
    return css`
        ${weights.map(({ weight, woff, woff2 }) => {
            const woffUrl = resolveAssetUrl(woff);
            const woff2Url = resolveAssetUrl(woff2);
            return css`
                @font-face {
                    font-family: '${family}';
                    font-style: normal;
                    font-weight: ${weight};
                    font-display: swap;
                    src:
                        local('${family}'),
                        url(${woff2Url}) format('woff2'),
                        url(${woffUrl}) format('woff');
                }
            `;
        })}
    `;
}
